import axios from 'axios';
import qs from 'qs';

/**
 * Effectue un appel AJAX global avec Axios.
 *
 * @param {string} url - L'URL de la requête.
 * @param {Object} params - Les paramètres de la requête.
 * @param {string} method - La méthode HTTP (GET, POST, PUT, DELETE, etc.).
 * @returns {Promise} - Une promesse qui retourne le résultat ou une erreur.
 */
export async function ajaxRequest(url, params = {}, method = 'POST') {
    try {
        const response = await axios({
            method,
            url,
            data: params,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest',
            },
            transformRequest: [(data) => qs.stringify(data)],
        });

        return response.data; // Les données de la réponse
    } catch (error) {
        console.error(`Erreur lors de la requête Ajax : ${error}`);
        throw error;
    }
}
